(function () {
  'use strict';
  var KEY = 'intimum_reveal_all';

  function revealCardMedia(media) {
    if (media) media.classList.add('is-revealed');
  }

  // Clique no botão "olho" dos cards
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.nsfw-reveal');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      revealCardMedia(btn.closest('.product-card__media, .bundles__media'));
      return;
    }
    var gbtn = e.target.closest('.product-gallery__nsfw');
    if (gbtn) {
      e.preventDefault();
      e.stopPropagation();
      var main = gbtn.closest('.product-gallery__main');
      if (main) main.classList.add('is-revealed');
      return;
    }
    // Toggle global "Modo Discreto"
    var t = e.target.closest('[data-discreet-toggle]');
    if (t) {
      e.preventDefault();
      var on = localStorage.getItem(KEY) === '1';
      if (on) { localStorage.removeItem(KEY); applyAll(false); }
      else { localStorage.setItem(KEY, '1'); applyAll(true); }
      updateToggle();
    }
  });

  function applyAll(reveal) {
    document.querySelectorAll('.product-card__media.is-nsfw, .product-gallery__main.is-nsfw, .bundles__media.is-nsfw').forEach(function (m) {
      if (reveal) m.classList.add('is-revealed');
      else m.classList.remove('is-revealed');
    });
  }

  function updateToggle() {
    var on = localStorage.getItem(KEY) === '1';
    document.querySelectorAll('[data-discreet-toggle]').forEach(function (el) {
      el.setAttribute('aria-pressed', on ? 'false' : 'true');
      el.classList.toggle('is-revealing', on);
      var label = el.querySelector('[data-discreet-label]');
      if (label) label.textContent = on ? 'Modo discreto: OFF' : 'Modo discreto: ON';
    });
  }

  function init() {
    if (localStorage.getItem(KEY) === '1') applyAll(true);
    updateToggle();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
